import type { TweetResponseBasicInfoAllOfTwoTweetType } from './tweetResponseBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type TweetResponseBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: TweetResponseBasicInfoAllOfTwoTweetType;
};
